import resultPlugin from '../resultPanelPlugin';
import OlsIsolineSummary from './olsIsolineSummary/OlsIsolineSummary';
import InspectSegmentResult from './inspectSegment/InspectSegmentResult';
import RouteSelector from './routeSelector/RouteSelector';

resultPlugin.register('olsIsolineSummary', OlsIsolineSummary);
resultPlugin.register('inspectSegment', InspectSegmentResult);
resultPlugin.register('routeSelector', RouteSelector);
